import React, { useEffect, useState } from 'react';
import { IconButton, SelectPicker, Tooltip, Whisper } from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';
import { CustomInput } from './costing-page';
import { cbmFunction } from './functions';
import { useLocation } from 'react-router-dom';
import globalIP from '@/GlobelIP';
// import { fetchComponent } from '@/apiService/apiService';
import axios from 'axios';
export type SubColumns = {
  label: string;
  key: string;
  renderCell: (_: any, index: number) => JSX.Element | number;
};
export type Columns = {
  [x: string]: any;
  label: string;
  key: string;
  fixed?: boolean;
  subColumns?: SubColumns[];

  renderCell?: (_: any, index: number) => JSX.Element | number;
};
export const unitData = [
  { label: 'Cm', value: 'Cm' },
  { label: 'Inch', value: 'Inch' }
];
export const PCSData = [
  { label: 'PCS', value: 'Pcs' },
  { label: 'Inch', value: 'Inch' }
];
export const unitData2 = [
  { label: 'Pcs', value: 'pcs' },
  { label: 'Kg', value: 'kg' },
  { label: 'Inch', value: 'inch' }
];
export default function useColumns(
  handleChange,
  costingTableData,
  handleDeleteRow,
  state,
  setFieldData,
  setReload,
  productData,
  fieldData,
  materialData,
  latest,
  setlatest,
  changeCount,
  setChangeCount,
  fetchProcessesOnMaterials
) {
  // Fetching component data
  // const [compdata, setCompdata] = useState([]);
  // const [isLoadingcomp, setIsLoadingcomp] = useState(false);
  // useEffect(() => {
  //   fetchComponent(setCompdata, isLoadingcomp, setIsLoadingcomp);
  // }, []);

  // useEffect(() => {
  //   setReload(prev => !prev)
  // }, [changeCount])
  const UpdateCBM = (index, CBM) => {
    if (CBM) {
      if (costingTableData.CostingWood[index]) {
        if (costingTableData.CostingWood[index].PCS) {
          costingTableData.CostingWood[index].CFT = CBM;
        }
      }
    } else {
      costingTableData.CostingWood[index].CFT = 0;
      costingTableData.CostingWood[index].woodamount = 0;
    }
    if (costingTableData.CostingWood[index]?.CFT && costingTableData.CostingWood[index]?.woodrate) {
      const result =
        Number(costingTableData.CostingWood[index]?.CFT) *
        Number(costingTableData.CostingWood[index]?.woodrate);
      if (costingTableData.CostingWood[index]) {
        if (costingTableData.CostingWood[index]?.woodrate) {
          costingTableData.CostingWood[index].woodamount = +result.toFixed(2);
        }
      }
    } else {
      costingTableData.CostingWood[index].woodamount = 0;
    }
    setChangeCount(prev => prev + 1);
  };
  const [categorydata, setCategorydata] = useState([]);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/mst-components?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mst-components?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CompName,
          value: item.attributes.CompName
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  useEffect(() => {
    if (productData?.ProductionDetail?.length && materialData) {
      const updatedCostingMaterial = productData.ProductionDetail.filter(detail =>
        state?.Material?.some(item => item.Type === 'cmaterial' && item.value === detail.MaterialNm)
      ).map(detail => {
        const matchedMaterial = materialData.find(
          mat =>
            mat.attributes.MaterialName === detail.MaterialNm && mat.attributes.Type === 'cmaterial'
        );

        return {
          chiefmaterial: detail.MaterialNm, // Set the MaterialNm from ProductionDetail
          component: detail.Component,
          unit: matchedMaterial?.attributes?.uom || 'kg', // Default or derive from detail if available
          wgtqty:
            matchedMaterial?.attributes?.uom == 'kg' || matchedMaterial?.attributes?.uom == ''
              ? detail.MatNetWeight
              : detail.Qty || detail.MatNetWeight,
          materialrate: matchedMaterial?.attributes?.Cost || 0, // Match and get cost
          batta: matchedMaterial?.attributes?.batta || 0, // Default batta
          totalmaterialcost: detail.MatNetWeight * (matchedMaterial?.attributes?.Cost || 0) || 0 // Calculate total cost
        };
      });
      handleChange('CostingMaterial', updatedCostingMaterial, 'init');

      if (updatedCostingMaterial.length > 0) {
        handleChange('CostingMaterial', updatedCostingMaterial[0]?.wgtqty, 'wgtqty', 0);
        setFieldData(prev => ({
          ...prev,
          Netwgt: 0
        }));
        setReload(prev => !prev);
      }
      setReload(prev => !prev);
    }
  }, [productData?.ProductionDetail, state?.Material, materialData]);

  const columns: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Chief Material',
      key: 'chiefMaterial',
      fixed: false,
      renderCell: (_, index) => {
        const chiefMaterialData = state?.Material?.filter(item => item.Type === 'cmaterial');
        // console.log('chiefMaterialData',chiefMaterialData);
        return (
          <SelectPicker
            data={chiefMaterialData}
            // searchable={false}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingMaterial[index]?.chiefmaterial}
            onChange={value => {
              // Update the chiefmaterial field
              handleChange('CostingMaterial', value, 'chiefmaterial', index);
              const matchedMaterial = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'cmaterial'
              );
              // Update the materialrate and totalmaterialcost dynamically
              handleChange(
                'CostingMaterial',
                matchedMaterial?.attributes?.Cost || 0,
                'materialrate',
                index
              );
              const weightQty = costingTableData.CostingMaterial[index]?.wgtqty || 0;
              handleChange(
                'CostingMaterial',
                weightQty * (matchedMaterial?.attributes?.Cost || 0),
                'totalmaterialcost',
                index
              );
              handleChange(
                'CostingMaterial',
                matchedMaterial?.attributes?.uom || 'kg',
                'unit',
                index
              );
              handleChange(
                'CostingMaterial',
                matchedMaterial?.attributes?.batta || 0,
                'batta',
                index
              );
              setReload(prev => !prev);
              fetchProcessesOnMaterials();
            }}
          />
        );
      }
    },
    {
      label: 'Component',
      key: 'component',
      fixed: false,
      renderCell: (_, index) => {
        // const componentData = state?.Material?.filter(item => item.Type === 'component');
        return (
          <SelectPicker
            data={categorydata}
            // searchable={false}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingMaterial[index]?.component}
            onChange={value => {
              // Update the component field
              handleChange('CostingMaterial', value, 'component', index);

              const matchedComponent = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'component'
              );

              // Optional: Update other related fields if needed
              handleChange(
                'CostingMaterial',
                matchedComponent?.attributes?.Cost || 0,
                'componentrate',
                index
              );

              const weightQty = costingTableData.CostingMaterial[index]?.wgtqty || 0;

              handleChange(
                'CostingMaterial',
                weightQty * (matchedComponent?.attributes?.Cost || 0),
                'totalcomponentcost',
                index
              );

              handleChange(
                'CostingMaterial',
                matchedComponent?.attributes?.uom || 'kg',
                'componentunit',
                index
              );

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'unit',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={unitData2}
            size="xs"
            disabled={!productData.isEdit}
            cleanable={false}
            searchable={false}
            style={{ width: '100%' }}
            value={costingTableData.CostingMaterial[index]?.unit}
            onChange={value => handleChange('CostingMaterial', value, 'unit', index)}
          />
        );
      }
    },
    {
      label: 'Weight/Qty',
      key: 'weightQty',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.wgtqty || 0}
            onChange={value => {
              handleChange('CostingMaterial', value, 'wgtqty', index);
              setFieldData(prev => ({
                ...prev,
                Netwgt: 0
              }));
              setReload(prev => !prev);
            }}
          />
        );
      }
    },

    {
      label: 'Material Rate',
      key: 'materialRate',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.materialrate || 0}
            onChange={value => {
              handleChange('CostingMaterial', value, 'materialrate', index);
              setFieldData(prev => ({
                ...prev,
                perkgrate: 0
              }));
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Batta',
      key: 'Batta',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.batta || 0}
            onChange={value => {
              handleChange('CostingMaterial', value, 'batta', index);
              setFieldData(prev => ({
                ...prev,
                perKgRate: 0
              }));
              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Total',
      key: 'total',
      fixed: false,
      renderCell: (rowData, index) => {
        let calculate = 0;
        if (rowData.materialrate || rowData.batta || rowData.wgtqty) {
          calculate =
            (Number(rowData.materialrate) + Number(rowData.batta)) * Number(rowData.wgtqty);
          if (costingTableData.CostingMaterial[index]) {
            costingTableData.CostingMaterial[index].totalmaterialcost = calculate;
          }
        }

        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingMaterial[index]?.totalmaterialcost.toFixed(2)}
            readOnly
            onChange={value => {
              handleChange('CostingMaterial', value, 'totalmaterialcost', index);
            }}
          />
        );
      }
    },
    {
      label: 'Add Material',
      key: 'addMaterial',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                color="red"
                appearance="primary"
                disabled={!productData.isEdit}
                onClick={() => handleDeleteRow('CostingMaterial', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];
  const convertUnit = (value, fromUnit, toUnit) => {
    if (!value || isNaN(value)) return 0;

    const inchToCm = 2.54;
    if (fromUnit == 'Inch' && toUnit == 'Cm') {
      return (Number(value) * inchToCm).toFixed(2);
    } else if (fromUnit == 'Cm' && toUnit == 'Inch') {
      return (Number(value) / inchToCm).toFixed(2);
    }
    return Number(value).toFixed(2); // No conversion needed if units are the same
  };

  useEffect(() => {
    if (productData?.ProductionDetail?.length && materialData) {
      // Filter and map only relevant wood materials
      const updatedCostingWood = productData.ProductionDetail.filter(detail =>
        state?.Material?.some(
          item =>
            (item.Type === 'wmaterial' || item.Type === 'mrmaterial') &&
            item.value === detail.MaterialNm
        )
      ).map(detail => {
        // Find the matching material and its rate
        const matchedMaterial = materialData.find(
          mat =>
            mat.attributes.MaterialName === detail.MaterialNm &&
            (mat.attributes.Type === 'wmaterial' || mat.attributes.Type === 'mrmaterial')
        );
        // console.log('matchedMaterial', matchedMaterial);
        // console.log('matchedMaterial?.attributes?.uom', matchedMaterial?.attributes?.uom);

        return {
          woodmaterial: detail.MaterialNm, // Set the MaterialNm from ProductionDetail
          Unit: matchedMaterial?.attributes?.uom, // Set the MaterialNm from ProductionDetail
          component: detail.Component || '', // Default value or fetch from detail
          quantity: detail.MatNetWeight || 0, // Default weight/quantity
          F_L: detail.Length, // Default unit
          F_W: detail.Width, // Default unit
          F_T: detail.Height, // Default unit
          PCS: detail.Qty, // Default unit
          F_Unit: detail.Unit == 'cm' ? 'Cm' : 'Inch', // Default unit
          R_Unit: detail.Unit == 'cm' ? 'Cm' : 'Inch',
          woodrate: matchedMaterial?.attributes?.Cost || 0 // Match and get cost
        };
      });

      // Initialize CostingWood data
      handleChange('CostingWood', updatedCostingWood, 'init');
      setReload(prev => !prev);
    }
  }, [productData?.ProductionDetail, state?.Material, materialData]);

  const handleCustomInputChangeFL = (rowData, value, index) => {
    handleChange('CostingWood', value, 'F_L', index);

    // Convert Final Size L to Raw Size L if needed
    const finalUnit = costingTableData.CostingWood[index]?.F_Unit;
    const rawUnit = costingTableData.CostingWood[index]?.R_Unit;
    let convertedR_L = convertUnit(value, finalUnit, rawUnit);

    convertedR_L = Math.ceil(Math.ceil(parseFloat(convertedR_L) + 4) / 6) * 6;
    handleChange('CostingWood', convertedR_L, 'R_L', index);

    const CBM = cbmFunction(costingTableData.CostingWood, index);
    UpdateCBM(index, CBM);
  };
  const handleCustomInputChangeFW = (rowData, value, index) => {
    handleChange('CostingWood', value, 'F_W', index);

    // Convert Final Size W to Raw Size W if needed
    const finalUnit = costingTableData.CostingWood[index]?.F_Unit;
    const rawUnit = costingTableData.CostingWood[index]?.R_Unit;
    let convertedR_W = convertUnit(value, finalUnit, rawUnit);
    convertedR_W = Number(convertedR_W) + (Number(convertedR_W) * 25) / 100;

    handleChange('CostingWood', convertedR_W, 'R_W', index);

    const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
    UpdateCBM(index, CBM);
  };
  const handleCustomInputChangeFT = (rowData, value, index) => {
    handleChange('CostingWood', value, 'F_T', index);

    // Convert Final Size T to Raw Size T if needed
    const finalUnit = costingTableData.CostingWood[index]?.F_Unit;
    const rawUnit = costingTableData.CostingWood[index]?.R_Unit;
    let convertedR_T = convertUnit(value, finalUnit, rawUnit);

    const decimalPart = parseFloat('.' + (convertedR_T + '').split('.')[1]);
    if (decimalPart < 0.5) {
      convertedR_T = Math.floor(Number(convertedR_T)) + 0.5;
    } else if (decimalPart > 0.5) {
      convertedR_T = Math.floor(Number(convertedR_T)) + 1;
    }

    handleChange('CostingWood', convertedR_T, 'R_T', index);

    const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
    UpdateCBM(index, CBM);
  };
  const cbmFunction2 = (L, W, T, U, pc, index) => {
    console.log('L', L);
    console.log('W', W);
    console.log('T', T);
    console.log('U', U);
    console.log('pc', pc);
    let CFT;
    if (L && W && T && U == 'Cm' && pc) {
      CFT =
        parseFloat(L) *
        0.0328084 *
        (parseFloat(W) * 0.0328084) *
        (parseFloat(T) * 0.0328084) *
        Number(pc);
      return CFT.toFixed(4);
    } else if (L && W && T && U == 'Inch' && pc) {
      CFT = ((parseFloat(L) * parseFloat(W) * parseFloat(T)) / 1728) * Number(pc);
      return CFT.toFixed(4);
    } else if (L && W && T && U == 'Mm' && pc) {
      CFT =
        parseFloat(L) *
        0.00328084 *
        (parseFloat(W) * 0.00328084) *
        (parseFloat(T) * 0.00328084) *
        Number(pc);
      return CFT.toFixed(4);
    } else {
      return null;
    }
  };
  const handleCustomInputChangeMain = (rowData, index) => {
    const matchedMaterial = materialData.find(
      mat => mat.attributes.MaterialName === rowData?.woodmaterial
    )?.attributes.Type;
    console.log('matchedMaterialtype', matchedMaterial);
    handleChange('CostingWood', matchedMaterial, 'Type', index);
    // console.log('matchedMaterial?.attributes?.uom', matchedMaterial?.attributes?.uom);
    console.log('rowData?.Unit', rowData?.Unit);
    // console.log('matchedMaterial', matchedMaterial);
    if (rowData?.Unit == 'cft') {
      // handleCustomUpdateCFT(rowData, index)
      const finalUnit = rowData?.F_Unit;
      const rawUnit = rowData?.R_Unit;
      let convertedR_L = rowData?.F_L;
      let convertedR_W = rowData?.F_W;
      let convertedR_T = rowData?.F_T;

      if (matchedMaterial !== 'mrmaterial') {
        convertedR_L = convertUnit(convertedR_L, finalUnit, rawUnit);
        convertedR_L = Math.ceil((parseFloat(convertedR_L) + 4) / 6) * 6;

        convertedR_W = convertUnit(convertedR_W, finalUnit, rawUnit);
        convertedR_W = Number(convertedR_W) + (Number(convertedR_W) * 25) / 100;

        convertedR_T = convertUnit(convertedR_T, finalUnit, rawUnit);
        const decimalPart = parseFloat('.' + convertedR_T.toString().split('.')[1]);
        convertedR_T =
          decimalPart < 0.5 ? Math.floor(convertedR_T) + 0.5 : Math.floor(convertedR_T) + 1;
      }

      handleChange('CostingWood', convertedR_L, 'R_L', index);
      handleChange('CostingWood', convertedR_W, 'R_W', index);
      handleChange('CostingWood', convertedR_T, 'R_T', index);

      const CBM = cbmFunctionMain(
        convertedR_L,
        convertedR_W,
        convertedR_T,
        rawUnit,
        rowData?.PCS,
        index
      );
      UpdateCBM(index, CBM);
    } else if (rowData?.Unit == 'sqft') {
      let l = rowData?.F_L;
      let w = rowData?.F_W;
      let t = rowData?.F_T;
      let R_Unit = rowData?.R_Unit;
      console.log('R_Unit', R_Unit);
      handleChange('CostingWood', l, 'R_L', index);
      handleChange('CostingWood', w, 'R_W', index);
      handleChange('CostingWood', t, 'R_T', index);
      let area = 0;
      if (R_Unit === 'feet') {
        area = l * w;
      } else if (R_Unit === 'Inch') {
        area = (l * w) / 144;
      } else if (R_Unit === 'mm') {
        area = l * 0.00328084 * (w * 0.00328084);
      } else if (R_Unit === 'Cm' || R_Unit === 'cm') {
        area = l * w * 0.00107639;
      } else if (R_Unit === 'sq_feet') {
        area = (l * w) / 144;
      }
      const PCS = rowData?.PCS || 1;

      const CFT = area * PCS;
      const woodamount = CFT * rowData?.woodrate;
      handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
      handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    } else if (rowData?.Unit == 'cbm') {
      let l = rowData?.F_L;
      let w = rowData?.F_W;
      let t = rowData?.F_T;
      let r_unit = rowData?.R_Unit;
      let PCS = rowData?.PCS;
      handleChange('CostingWood', l, 'R_L', index);
      handleChange('CostingWood', w, 'R_W', index);
      handleChange('CostingWood', t, 'R_T', index);
      let area = 0;
      if (r_unit == 'Inch') {
        area = (l * t * w) / 61023;
      } else if (r_unit == 'Cm') {
        area = (l * t * w) / 1000000;
      } else if (r_unit == 'mm') {
        area = (l * t * w) / 1000000000;
      }
      const CFT = area * PCS;
      const woodamount = CFT * rowData?.woodrate;
      handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
      handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
      setChangeCount(prev => prev + 1);
    }
    setChangeCount(prev => prev + 1);
  };
  const handleCustomUpdateCFT = (rowData, index) => {
    const finalUnit = rowData?.F_Unit;
    const rawUnit = rowData?.R_Unit;
    let convertedR_L = rowData?.R_L;
    let convertedR_W = rowData?.R_W;
    let convertedR_T = rowData?.R_T;
    if (rowData.Type == 'wmaterial' && rowData.Unit == 'cft') {
      convertedR_L = rowData?.F_L;
      convertedR_W = rowData?.F_W;
      convertedR_T = rowData?.F_T;
      convertedR_L = convertUnit(convertedR_L, finalUnit, rawUnit);
      convertedR_L = Math.ceil((parseFloat(convertedR_L) + 4) / 6) * 6;

      convertedR_W = convertUnit(convertedR_W, finalUnit, rawUnit);
      convertedR_W = Number(convertedR_W) + (Number(convertedR_W) * 25) / 100;

      convertedR_T = convertUnit(convertedR_T, finalUnit, rawUnit);
      const decimalPart = parseFloat('.' + convertedR_T.toString().split('.')[1]);
      convertedR_T =
        decimalPart < 0.5 ? Math.floor(convertedR_T) + 0.5 : Math.floor(convertedR_T) + 1;
    }
    let area = 0;
    if (rawUnit === 'feet') {
      area = (convertedR_L * convertedR_W * convertedR_T) / 144;
    } else if (rawUnit === 'Inch') {
      area = (convertedR_L * convertedR_W * convertedR_T) / 1728;
    } else if (rawUnit === 'mm') {
      area = convertedR_L * 0.00328084 * (convertedR_W * 0.00328084) * (convertedR_T * 0.00328084);
    } else if (rawUnit === 'Cm' || rawUnit === 'cm') {
      area =
        (convertedR_L * 0.0328084 * (convertedR_W * 0.393701) * (convertedR_T * 0.393701)) / 144;
    } else if (rawUnit === 'sq_feet') {
      area = (convertedR_L * convertedR_W) / 144;
    }

    handleChange('CostingWood', convertedR_L, 'R_L', index);
    handleChange('CostingWood', convertedR_W, 'R_W', index);
    handleChange('CostingWood', convertedR_T, 'R_T', index);
    const PCS = rowData?.PCS || 1;
    const CFT = area * PCS;
    const woodamount = CFT * rowData?.woodrate;
    handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
    handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    setChangeCount(prev => prev + 1);
  };
  const handleCustomUpdateCBM = (rowData, index) => {
    let l = rowData?.R_L;
    let w = rowData?.R_W;
    let t = rowData?.R_T;
    let r_unit = rowData?.R_Unit;
    let PCS = rowData?.PCS;
    handleChange('CostingWood', l, 'R_L', index);
    handleChange('CostingWood', w, 'R_W', index);
    handleChange('CostingWood', t, 'R_T', index);
    let area = 0;
    if (r_unit == 'Inch') {
      area = (l * t * w) / 61023;
    } else if (r_unit == 'Cm') {
      area = (l * t * w) / 1000000;
    } else if (r_unit == 'mm') {
      area = (l * t * w) / 1000000000;
    }
    const CFT = area * PCS;
    const woodamount = CFT * rowData?.woodrate;
    handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
    handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    setChangeCount(prev => prev + 1);
  };
  const handleCustomUpdateSQFT = (rowData, index) => {
    let l = rowData?.R_L;
    let w = rowData?.R_W;
    let t = rowData?.R_T;
    let R_Unit = rowData?.R_Unit;
    console.log('R_Unit', R_Unit);
    handleChange('CostingWood', l, 'R_L', index);
    handleChange('CostingWood', w, 'R_W', index);
    handleChange('CostingWood', t, 'R_T', index);
    let area = 0;
    if (R_Unit === 'feet') {
      area = l * w;
    } else if (R_Unit === 'Inch') {
      area = (l * w) / 144;
    } else if (R_Unit === 'mm') {
      area = l * 0.00328084 * (w * 0.00328084);
    } else if (R_Unit === 'Cm' || R_Unit === 'cm') {
      area = l * w * 0.00107639;
    } else if (R_Unit === 'sq_feet') {
      area = (l * w) / 144;
    }
    const PCS = rowData?.PCS || 1;

    const CFT = area * PCS;
    const woodamount = CFT * rowData?.woodrate;
    handleChange('CostingWood', CFT.toFixed(3), 'CFT', index);
    handleChange('CostingWood', woodamount.toFixed(3), 'woodamount', index);
    setChangeCount(prev => prev + 1);
  };
  const handleCustomUpdatePCS = (rowData, index) => {
    const pcs = Number(rowData?.PCS || 0);
    const rate = Number(rowData?.woodrate || 0);
    const woodamount = pcs * rate;

    handleChange('CostingWood', pcs, 'PCS', index);
    handleChange('CostingWood', pcs, 'CFT', index); // QTY is same as PCS in 'pcs' unit
    handleChange('CostingWood', woodamount.toFixed(2), 'woodamount', index);

    setChangeCount(prev => prev + 1);
  };

  useEffect(() => {
    if (!fieldData.updatedAt || latest) {
      costingTableData.CostingWood.forEach((item, index) => {
        handleCustomInputChangeMain(item, index);
      });
      setlatest(false);
      // console.log('hi')
    }
  }, [costingTableData.CostingWood, latest]);
  const unittype = [
    { label: 'Sq ft', value: 'sqft' },
    // { label: 'cu ft', value: 'cuft' },
    { label: 'CFT', value: 'cft' },
    { label: 'CBM', value: 'cbm' },
    { label: 'KG', value: 'kg' },
    { label: 'Pcs', value: 'pcs' },
    { label: 'Inch', value: 'inch' }
  ];

  const uomMapping = {
    wmaterial: [
      'sqft',
      'cft',
      'pcs'
      // 'inch'
    ],
    mrmaterial: [
      'sqft',
      'cft',
      'cbm',
      'pcs'
      // 'inch'
    ],
    cmaterial: ['kg', 'pcs', 'inch']
  };
  const marbelUnitData = unittype.filter(item => {
    return uomMapping.mrmaterial.includes(item.value.toLowerCase());
  });
  const woodUnitData = unittype.filter(item =>
    uomMapping.wmaterial.includes(item.value.toLowerCase())
  );
  const columns1: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Wood / Marble Material',
      key: 'woodmaterial',
      fixed: false,
      renderCell: (_, index) => {
        const woodMaterialData = state?.Material?.filter(
          item => item.Type === 'wmaterial' || item.Type === 'mrmaterial'
        );
        return (
          <SelectPicker
            cleanable={false}
            disabled={!productData.isEdit}
            data={woodMaterialData}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingWood[index]?.woodmaterial}
            onChange={value => {
              // Update woodmaterial field
              handleChange('CostingWood', value, 'woodmaterial', index);

              // Find the selected material's rate
              const matchedMaterial = materialData.find(
                mat =>
                  mat.attributes.MaterialName === value &&
                  (mat.attributes.Type === 'wmaterial' || mat.attributes.Type === 'mrmaterial')
              );

              // Update woodrate dynamically
              handleChange(
                'CostingWood',
                matchedMaterial?.attributes?.Cost || 0,
                'woodrate',
                index
              );
              handleChange('CostingWood', matchedMaterial?.attributes?.uom || 0, 'Unit', index);
              handleChange('CostingWood', matchedMaterial?.attributes?.Type || 0, 'Type', index);

              // Recalculate woodamount if CFT exists
              const cft = costingTableData.CostingWood[index]?.CFT || 0;
              const newWoodAmount = cft * (matchedMaterial?.attributes?.Cost || 0);
              handleChange('CostingWood', +newWoodAmount.toFixed(2), 'woodamount', index);

              setReload(prev => !prev);
              fetchProcessesOnMaterials();
            }}
          />
        );
      }
    },
    {
      label: 'Components',
      key: 'components',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={categorydata}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingWood[index]?.component}
            onChange={value => handleChange('CostingWood', value, 'component', index)}
          />
        );
      }
    },
    {
      label: 'Final Size',
      key: 'finalSize',
      fixed: false,
      subColumns: [
        {
          label: 'L',
          key: 'L',
          renderCell: (rowData, index) => {
            return (
              <CustomInput
                step={null}
                placeholder="0.00"
                value={costingTableData.CostingWood[index]?.F_L || 0}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_L', index);
                  if (rowData.Unit == 'cft') {
                    const temprowdata = rowData;
                    temprowdata.F_L = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.F_L = value;
                    temprowdata.R_L = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.F_L = value;
                    temprowdata.R_L = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                }}
              />
            );
          }
        },
        {
          label: 'W',
          key: 'W',
          renderCell: (rowData, index) => {
            return (
              <CustomInput
                step={null}
                placeholder="0.00"
                value={costingTableData.CostingWood[index]?.F_W || 0}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_W', index);
                  if (rowData.Unit == 'cft') {
                    // Convert Final Size W
                    const temprowdata = rowData;
                    temprowdata.F_W = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.F_W = value;
                    temprowdata.R_W = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.F_W = value;
                    temprowdata.R_W = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                }}
              />
            );
          }
        },
        {
          label: 'T',
          key: 'T',
          renderCell: (rowData, index) => {
            return (
              <CustomInput
                step={null}
                placeholder="0.00"
                value={costingTableData.CostingWood[index]?.F_T || 0}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_T', index);
                  if (rowData.Unit == 'cft') {
                    const temprowdata = rowData;
                    temprowdata.F_T = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.F_T = value;
                    temprowdata.R_T = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.F_T = value;
                    temprowdata.R_T = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                }}
              />
            );
          }
        },
        {
          label: 'Unit',
          key: 'unit',
          renderCell: (rowData, index) => {
            return (
              <SelectPicker
                data={unitData}
                cleanable={false}
                disabled={!productData.isEdit}
                size="xs"
                searchable={false}
                style={{ width: '100%' }}
                value={costingTableData.CostingWood[index]?.F_Unit}
                onChange={value => {
                  handleChange('CostingWood', value, 'F_Unit', index);
                  // Convert Final Size to Raw Size when changing unit
                  const { F_L, F_W, F_T } = costingTableData.CostingWood[index];
                  const rawUnit = costingTableData.CostingWood[index]?.R_Unit;

                  let updatedR_L = convertUnit(F_L, value, rawUnit);
                  let updatedR_W = convertUnit(F_W, value, rawUnit);
                  let updatedR_T = convertUnit(F_T, value, rawUnit);
                  updatedR_L = Math.ceil(Math.ceil(parseFloat(updatedR_L) + 4) / 6) * 6;
                  updatedR_W = Number(updatedR_W) + (Number(updatedR_W) * 25) / 100;
                  if (parseFloat('.' + (updatedR_T + '').split('.')[1]) < 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 0.5;
                  } else if (parseFloat('.' + (updatedR_T + '').split('.')[1]) > 0.5) {
                    updatedR_T = Math.floor(Number(updatedR_T)) + 1;
                  }
                  handleChange('CostingWood', updatedR_L, 'R_L', index);
                  handleChange('CostingWood', updatedR_W, 'R_W', index);
                  handleChange('CostingWood', updatedR_T, 'R_T', index);

                  // Calculate and update CBM
                  const updatedCBM = cbmFunction(
                    {
                      R_L: updatedR_L,
                      R_W: updatedR_W,
                      R_T: updatedR_T,
                      R_Unit: rawUnit
                    },
                    costingTableData.CostingWood[index]?.PCS
                  );
                  UpdateCBM(index, updatedCBM);
                }}
              />
            );
          }
        }
      ]
    },
    {
      label: 'Raw Size',
      key: 'rawSize',
      fixed: false,
      subColumns: [
        {
          label: 'L',
          key: 'L',
          renderCell: (rowData, index) => (
            <CustomInput
              step={null}
              placeholder="0.00"
              value={costingTableData.CostingWood[index]?.R_L || 0}
              onChange={value => {
                handleChange('CostingWood', value, 'R_L', index);
                if (rowData.Unit == 'cft') {
                  const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
                  UpdateCBM(index, CBM);
                } else if (rowData.Unit == 'cbm') {
                  const temprowdata = rowData;
                  temprowdata.R_L = value;
                  handleCustomUpdateCBM(temprowdata, index);
                } else if (rowData.Unit == 'sqft') {
                  const temprowdata = rowData;
                  temprowdata.R_L = value;
                  handleCustomUpdateSQFT(temprowdata, index);
                }
              }}
            />
          )
        },
        {
          label: 'W',
          key: 'W',
          renderCell: (rowData, index) => (
            <CustomInput
              step={null}
              placeholder="0.00"
              value={costingTableData.CostingWood[index]?.R_W || 0}
              onChange={value => {
                if (rowData.Unit == 'cft') {
                  handleChange('CostingWood', value, 'R_W', index);
                  const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
                  UpdateCBM(index, CBM);
                } else if (rowData.Unit == 'cbm') {
                  const temprowdata = rowData;
                  temprowdata.R_W = value;
                  handleCustomUpdateCBM(temprowdata, index);
                } else if (rowData.Unit == 'sqft') {
                  const temprowdata = rowData;
                  temprowdata.R_W = value;
                  handleCustomUpdateSQFT(temprowdata, index);
                }
              }}
            />
          )
        },
        {
          label: 'T',
          key: 'T',
          renderCell: (rowData, index) => (
            <CustomInput
              step={null}
              placeholder="0.00"
              value={costingTableData.CostingWood[index]?.R_T || 0}
              onChange={value => {
                if (rowData.Unit == 'cft') {
                  handleChange('CostingWood', value, 'R_T', index);
                  const CBM = cbmFunction(rowData, costingTableData.CostingWood[index]?.PCS);
                  UpdateCBM(index, CBM);
                } else if (rowData.Unit == 'cbm') {
                  const temprowdata = rowData;
                  temprowdata.R_T = value;
                  handleCustomUpdateCBM(temprowdata, index);
                } else if (rowData.Unit == 'sqft') {
                  const temprowdata = rowData;
                  temprowdata.R_T = value;
                  handleCustomUpdateSQFT(temprowdata, index);
                }
              }}
            />
          )
        },
        {
          label: 'Unit',
          key: 'unit',
          renderCell: (rowData, index) => {
            const rawUnit = costingTableData.CostingWood[index]?.R_Unit || 'inch';
            const finalUnit = costingTableData.CostingWood[index]?.F_Unit || 'inch';
            const finalData = costingTableData.CostingWood[index];
            return (
              <SelectPicker
                data={unitData}
                disabled={!productData.isEdit}
                size="xs"
                cleanable={false}
                searchable={false}
                style={{ width: '100%' }}
                value={rawUnit}
                onChange={value => {
                  handleChange('CostingWood', value, 'R_Unit', index);
                  console.log('rowData', rowData);
                  if (rowData.Unit == 'cft') {
                    const temprowdata = rowData;
                    temprowdata.R_Unit = value;
                    handleCustomUpdateCFT(temprowdata, index);
                  } else if (rowData.Unit == 'cbm') {
                    const temprowdata = rowData;
                    temprowdata.R_Unit = value;
                    handleCustomUpdateCBM(temprowdata, index);
                  } else if (rowData.Unit == 'sqft') {
                    const temprowdata = rowData;
                    temprowdata.R_Unit = value;
                    handleCustomUpdateSQFT(temprowdata, index);
                  }
                }}
              />
            );
          }
        }
      ]
    },
    {
      label: 'Pcs',
      key: 'pcs',
      fixed: false,
      renderCell: (rowData, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingWood[index]?.PCS || 0}
            onChange={value => {
              handleChange('CostingWood', value, 'PCS', index);
              // Update amount if Unit is pcs
              if (rowData.Unit === 'pcs') {
                const rate = costingTableData.CostingWood[index]?.woodrate || 0;
                const pcs = Number(value || 0);
                const amount = pcs * Number(rate);
                handleChange('CostingWood', +amount.toFixed(2), 'woodamount', index);
                setReload(prev => !prev); // Trigger re-render if needed
              }
              if (rowData.Unit == 'cft') {
                const temprowdata = rowData;
                temprowdata.PCS = value;
                handleCustomUpdateCFT(temprowdata, index);
              } else if (rowData.Unit == 'cbm') {
                const temprowdata = rowData;
                temprowdata.PCS = value;
                handleCustomUpdateCBM(temprowdata, index);
              } else if (rowData.Unit == 'sqft') {
                const temprowdata = rowData;
                temprowdata.PCS = value;
                handleCustomUpdateSQFT(temprowdata, index);
              }
            }}
          />
        );
      }
    },
    {
      label: 'Unit',
      key: 'CFT unit',
      fixed: false,
      renderCell: (rowData, index) => {
        return (
          <SelectPicker
            cleanable={false}
            size="xs"
            placeholder={costingTableData.CostingWood[index]?.Unit}
            style={{ width: '60%' }}
            searchable={false}
            value={costingTableData.CostingWood[index]?.Unit || 0}
            data={
              costingTableData.CostingWood[index]?.Type != 'wmaterial'
                ? marbelUnitData
                : woodUnitData
            }
            onChange={value => {
              handleChange('CostingWood', value, 'Unit', index);
              if (value == 'cft') {
                handleCustomUpdateCFT(rowData, index);
              } else if (value == 'cbm') {
                handleCustomUpdateCBM(rowData, index);
              } else if (value == 'sqft') {
                handleCustomUpdateSQFT(rowData, index);
              } else if (value === 'pcs') {
                handleCustomUpdatePCS(rowData, index);
              }
            }}
          />
        );
      }
    },
    {
      label: 'QTY',
      key: 'CFT QTY',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            // value={(costingTableData.CostingWood[index]?.CFT / 1).toFixed(3)}
            value={
              costingTableData.CostingWood[index]?.Unit === 'pcs'
                ? costingTableData.CostingWood[index]?.PCS || 0
                : (costingTableData.CostingWood[index]?.CFT / 1)?.toFixed(3)
            }
            readOnly
            onChange={value => handleChange('CostingWood', value, 'CFT', index)}
          />
        );
      }
    },
    {
      label: 'Rate',
      key: 'rate',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingWood[index]?.woodrate || 0}
            onChange={value => {
              handleChange('CostingWood', value, 'woodrate', index);
              const row = costingTableData.CostingWood[index];

              let amount = 0;
              if (row?.Unit === 'pcs') {
                amount = Number(row?.PCS || 0) * Number(value || 0);
              } else {
                amount = Number(row?.CFT || 0) * Number(value || 0);
              }

              costingTableData.CostingWood[index].woodamount = +amount.toFixed(2);
              setReload(prev => !prev);
            }}

            // onChange={value => {
            //   handleChange('CostingWood', value, 'woodrate', index);
            //   if (costingTableData.CostingWood[index]?.CFT && value) {
            //     const result = Number(costingTableData.CostingWood[index]?.CFT) * Number(value);
            //     if (costingTableData.CostingWood[index]) {
            //       if (value) {
            //         costingTableData.CostingWood[index].woodamount = +result.toFixed(2);
            //       }
            //     }
            //   } else {
            //     costingTableData.CostingWood[index].woodamount = 0;
            //   }
            //   setReload(prev => !prev);
            // }}
          />
        );
      }
    },
    {
      label: 'Amount',
      key: 'amount',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingWood[index]?.woodamount}
            readOnly
            onChange={value => handleChange('CostingWood', value, 'woodamount', index)}
          />
        );
      }
    },
    {
      label: 'Add Material',
      key: 'addMaterial',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                disabled={!productData.isEdit}
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('CostingWood', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];

  const { Height, Length, Width, SizeUnit } = productData;

  const convertedHeight = SizeUnit === 'cm' ? Height / 2.54 : Height;
  const convertedLength = SizeUnit === 'cm' ? Length / 2.54 : Length;
  const convertedWidth = SizeUnit === 'cm' ? Width / 2.54 : Width;

  const highestValue = Math.max(
    parseFloat(convertedHeight),
    parseFloat(convertedLength),
    parseFloat(convertedWidth)
  );

  const columns2: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Process',
      key: 'process',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={state?.Process?.map(item => ({
              label: item.label,
              value: item.value
            }))}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingProcess[index]?.Process}
            onChange={value => {
              const selectedProcess = state?.Process?.find(item => item.value === value);
              const price = selectedProcess?.Price || 0; // Get the price for the selected process
              handleChange('CostingProcess', price, 'prcsrate', index); // Update rate first

              // Check ProcessTyp and recalculate prcsamt
              if (costingTableData.CostingProcess[index]?.ProcessTyp === 'Inch') {
                if (costingTableData.CostingProcess[index]) {
                  const size = +costingTableData.CostingProcess[index].size || 0;
                  const result = size * price; // Multiply size by the new rate
                  handleChange('CostingProcess', result, 'prcsamt', index); // Update amount
                }
              } else {
                if (costingTableData.CostingProcess[index]) {
                  handleChange('CostingProcess', price, 'prcsamt', index); // Use the rate directly
                }
              }

              handleChange('CostingProcess', value, 'Process', index); // Update process value
              setReload(prev => !prev); // Trigger re-render

              // Reset size and rate fields in FieldData if necessary
              setFieldData(prev => ({
                ...prev,
                size: 0,
                rate: 0
              }));
            }}
          />
        );
      }
    },
    {
      label: 'Prc Type',
      key: 'prcType',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <SelectPicker
            data={PCSData}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            searchable={false}
            cleanable={false}
            value={costingTableData.CostingProcess[index]?.ProcessTyp}
            onChange={value => {
              handleChange('CostingProcess', value, 'ProcessTyp', index);
              let sizeValue = highestValue.toFixed(2);
              let amount = 0;
              if (costingTableData.CostingProcess[index]) {
                handleChange('CostingProcess', sizeValue, 'size', index);
                if (value === 'Inch') {
                  amount = sizeValue * +costingTableData.CostingProcess[index].prcsrate;
                } else {
                  amount = +costingTableData.CostingProcess[index].prcsrate;
                }
                handleChange('CostingProcess', amount, 'prcsamt', index);
              }
              const totalProcessCost = costingTableData?.CostingProcess?.reduce(
                (sum, row, i) =>
                  i === index
                    ? sum + (parseFloat(amount) || 0)
                    : sum + (parseFloat(row?.prcsamt) || 0),
                0
              );
              setFieldData(prev => ({
                ...prev,
                processcost: totalProcessCost
              }));
              setReload(prev => !prev);
              setFieldData(prev => ({
                ...prev,
                size: 0,
                rate: 0
              }));
            }}
          />
        );
      }
    },
    {
      label: 'Size',
      key: 'size',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingProcess[index]?.size}
            disabled
            onChange={value => {
              handleChange('CostingProcess', value, 'size', index);
            }}
          />
        );
      }
    },

    {
      label: 'Rate',
      key: 'rate',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingProcess[index]?.prcsrate || 0}
            onChange={value => {
              handleChange('CostingProcess', value, 'prcsrate', index);

              const rate = parseFloat(value) || 0;
              const size = parseFloat(costingTableData.CostingProcess[index]?.size) || 0;

              let amount = rate;
              if (costingTableData.CostingProcess[index]?.ProcessTyp === 'Inch') {
                amount = rate * size;
              }

              handleChange('CostingProcess', amount, 'prcsamt', index);

              // ✅ Recalculate total process cost
              const totalProcessCost = costingTableData?.CostingProcess?.reduce(
                (sum, row, i) =>
                  i === index
                    ? sum + (parseFloat(amount) || 0)
                    : sum + (parseFloat(row?.prcsamt) || 0),
                0
              );

              // ✅ Update fieldData.processcost
              setFieldData(prev => ({
                ...prev,
                processcost: totalProcessCost
              }));

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Amount',
      key: 'amount',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            readOnly
            value={costingTableData.CostingProcess[index]?.prcsamt}
            onChange={value => handleChange('CostingProcess', value, 'prcsamt', index)}
          />
        );
      }
    },
    {
      label: 'Add Material',
      key: 'addMaterial',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                disabled={!productData.isEdit}
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('CostingProcess', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];

  const columns3: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => {
        return rowIndex + 1;
      }
    },
    {
      label: 'Material',
      key: 'material',
      fixed: false,
      renderCell: (_, index) => {
        const woodMaterialData = state?.Material?.filter(item => item.Type === 'amaterial');
        return (
          <SelectPicker
            disabled={!productData.isEdit}
            data={woodMaterialData}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.CostingAccessory[index]?.materialname}
            onChange={value => {
              // Update the materialname field
              handleChange('CostingAccessory', value, 'materialname', index);
              const matchedMaterial = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'amaterial'
              );
              // Extract its cost (default to 0)
              const cost = matchedMaterial?.attributes?.Cost || 0;
              // Update the matcost dynamically
              handleChange(
                'CostingAccessory',
                matchedMaterial?.attributes?.Cost || 0,
                'matcost',
                index
              );
              // ✅ Recalculate total matcost including updated cost
              const totalMatCost = costingTableData?.CostingAccessory?.reduce(
                (sum, row, i) =>
                  i === index
                    ? sum + (parseFloat(cost) || 0)
                    : sum + (parseFloat(row?.matcost) || 0),
                0
              );

              // ✅ Update wiringcost in fieldData
              setFieldData(prev => ({
                ...prev,
                wiringcost: totalMatCost
              }));

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Cost',
      key: 'cost',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingAccessory[index]?.matcost || 0}
            onChange={value => {
              handleChange('CostingAccessory', value, 'matcost', index);

              const qty = parseFloat(costingTableData.CostingAccessory[index]?.qty) || 0;
              const matcost = parseFloat(value) || 0;
              const amount = matcost * qty;

              // update amount
              handleChange('CostingAccessory', amount, 'amount', index);

              // sum of all amounts as wiringcost
              const totalWiringCost = costingTableData.CostingAccessory.reduce(
                (sum, row, i) =>
                  i === index ? sum + amount : sum + (parseFloat(row?.amount) || 0),
                0
              );

              setFieldData(prev => ({
                ...prev,
                wiringcost: totalWiringCost
              }));

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Qty',
      key: 'qty',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingAccessory[index]?.qty || 0}
            onChange={value => {
              handleChange('CostingAccessory', value, 'qty', index);

              const matcost = parseFloat(costingTableData.CostingAccessory[index]?.matcost) || 0;
              const qty = parseFloat(value) || 0;
              const amount = matcost * qty;

              // update amount
              handleChange('CostingAccessory', amount, 'amount', index);

              // sum of all amounts as wiringcost
              const totalWiringCost = costingTableData.CostingAccessory.reduce(
                (sum, row, i) =>
                  i === index ? sum + amount : sum + (parseFloat(row?.amount) || 0),
                0
              );

              setFieldData(prev => ({
                ...prev,
                wiringcost: totalWiringCost
              }));

              setReload(prev => !prev);
            }}
          />
        );
      }
    },
    {
      label: 'Amount',
      key: 'amount',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <CustomInput
            step={null}
            placeholder="0.00"
            value={costingTableData.CostingAccessory[index]?.amount || 0}
            disabled
          />
        );
      }
    },
    {
      label: 'Add Accessories',
      key: 'addAccessories',
      fixed: false,
      renderCell: (_, index) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Whisper
              followCursor
              placement="right"
              trigger="hover"
              speaker={<Tooltip>Delete</Tooltip>}
            >
              <IconButton
                icon={<TrashIcon />}
                size="sm"
                disabled={!productData.isEdit}
                color="red"
                appearance="primary"
                onClick={() => handleDeleteRow('CostingAccessory', index)}
              />
            </Whisper>
          </div>
        );
      }
    }
  ];
  const recalculatePackingCost = () => {
    const totalPackingCost = costingTableData?.Costingpacking?.reduce(
      (sum, row) => sum + (parseFloat(row?.packingtotalcost) || 0),
      0
    );
    setFieldData(prev => ({
      ...prev,
      packingcost: totalPackingCost
    }));
  };
  const columns4: Columns[] = [
    {
      label: 'S.no',
      key: 'id',
      fixed: true,
      renderCell: (_, rowIndex) => rowIndex + 1
    },
    {
      label: 'Type',
      key: 'type',
      fixed: false,
      renderCell: (_, index) => (
        <SelectPicker
          data={[
            { label: 'Carton', value: 'carton' },
            { label: 'Thermacol', value: 'thermacol' }
          ]}
          disabled={!productData.isEdit}
          size="xs"
          style={{ width: '100%' }}
          value={costingTableData.Costingpacking[index]?.packingtype}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingtype', index);
            if (value === 'carton') {
              handleChange('Costingpacking', 0, 'packingHeight', index);
              handleChange('Costingpacking', 0, 'packingsizeRate', index);
              handleChange('Costingpacking', 0, 'packingQT', index);
            }
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'Material',
      key: 'material',
      fixed: false,
      renderCell: (_, index) => {
        const woodMaterialData = state?.Material?.filter(item => item.Type === 'pmaterial');
        return (
          <SelectPicker
            data={woodMaterialData}
            disabled={!productData.isEdit}
            size="xs"
            style={{ width: '100%' }}
            value={costingTableData.Costingpacking[index]?.packingmaterial}
            onChange={value => {
              handleChange('Costingpacking', value, 'packingmaterial', index);
              const matchedMaterial = materialData.find(
                mat => mat.attributes.MaterialName === value && mat.attributes.Type === 'pmaterial'
              );
              const cost = matchedMaterial?.attributes?.Cost || 0;
              handleChange('Costingpacking', cost, 'packingcost', index);

              const { packingLength, packingWidth, packingHeight, packingtype, packingQT } =
                costingTableData.Costingpacking[index];

              const total =
                packingtype === 'carton'
                  ? ((packingLength * packingWidth) / 2400) * cost
                  : ((packingLength * packingWidth * packingHeight * cost) / 480249000) * packingQT;

              handleChange('Costingpacking', total.toFixed(2), 'packingtotalcost', index);
              if (packingtype === 'thermacol') {
                const sizerate = (packingLength * packingWidth * packingHeight * cost) / 480249000;
                handleChange('Costingpacking', sizerate.toFixed(2), 'packingsizeRate', index);
              }

              setReload(prev => !prev);
              recalculatePackingCost();
            }}
          />
        );
      }
    },
    {
      label: 'Length',
      key: 'Length',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          value={costingTableData.Costingpacking[index]?.packingLength || 0}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingLength', index);
            const { packingWidth, packingHeight, packingcost, packingtype, packingQT } =
              costingTableData.Costingpacking[index];

            if (packingtype === 'carton') {
              handleChange(
                'Costingpacking',
                (((value * packingWidth) / 2400) * packingcost).toFixed(2),
                'packingtotalcost',
                index
              );
            } else if (packingtype === 'thermacol') {
              const vol = value * packingWidth * packingHeight;
              const sizerate = (vol * packingcost) / 480249000;
              const total = sizerate * packingQT;
              handleChange('Costingpacking', sizerate.toFixed(2), 'packingsizeRate', index);
              handleChange('Costingpacking', total.toFixed(2), 'packingtotalcost', index);
            }
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'Width',
      key: 'Width',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          value={costingTableData.Costingpacking[index]?.packingWidth || 0}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingWidth', index);
            const { packingLength, packingHeight, packingcost, packingtype, packingQT } =
              costingTableData.Costingpacking[index];

            if (packingtype === 'carton') {
              handleChange(
                'Costingpacking',
                (((value * packingLength) / 2400) * packingcost).toFixed(2),
                'packingtotalcost',
                index
              );
            } else if (packingtype === 'thermacol') {
              const vol = value * packingLength * packingHeight;
              const sizerate = (vol * packingcost) / 480249000;
              const total = sizerate * packingQT;
              handleChange('Costingpacking', sizerate.toFixed(2), 'packingsizeRate', index);
              handleChange('Costingpacking', total.toFixed(2), 'packingtotalcost', index);
            }
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'Height',
      key: 'Height',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          disabled={costingTableData.Costingpacking[index]?.packingtype !== 'thermacol'}
          value={costingTableData.Costingpacking[index]?.packingHeight || 0}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingHeight', index);
            const { packingLength, packingWidth, packingcost, packingQT } =
              costingTableData.Costingpacking[index];
            const vol = value * packingWidth * packingLength;
            const sizerate = (vol * packingcost) / 480249000;
            const total = sizerate * packingQT;
            handleChange('Costingpacking', sizerate.toFixed(2), 'packingsizeRate', index);
            handleChange('Costingpacking', total.toFixed(2), 'packingtotalcost', index);
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'Rate',
      key: 'cost',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          value={costingTableData.Costingpacking[index]?.packingcost || 0}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingcost', index);
            const { packingLength, packingWidth, packingHeight, packingtype, packingQT } =
              costingTableData.Costingpacking[index];

            if (packingtype === 'carton') {
              handleChange(
                'Costingpacking',
                (((packingLength * packingWidth) / 2400) * value).toFixed(2),
                'packingtotalcost',
                index
              );
            } else if (packingtype === 'thermacol') {
              const vol = packingHeight * packingWidth * packingLength;
              const sizerate = (vol * value) / 480249000;
              const total = sizerate * packingQT;
              handleChange('Costingpacking', sizerate.toFixed(2), 'packingsizeRate', index);
              handleChange('Costingpacking', total.toFixed(2), 'packingtotalcost', index);
            }
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'SizeRate',
      key: 'sizeRate',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          readOnly
          disabled={costingTableData.Costingpacking[index]?.packingtype !== 'thermacol'}
          value={costingTableData.Costingpacking[index]?.packingsizeRate || 0}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingsizeRate', index);
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'QTY',
      key: 'qty',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          disabled={costingTableData.Costingpacking[index]?.packingtype !== 'thermacol'}
          value={costingTableData.Costingpacking[index]?.packingQT || 0}
          onChange={value => {
            handleChange('Costingpacking', value, 'packingQT', index);
            const { packingLength, packingWidth, packingHeight, packingcost, packingtype } =
              costingTableData.Costingpacking[index];

            if (packingtype === 'carton') {
              handleChange(
                'Costingpacking',
                (((packingLength * packingWidth) / 2400) * packingcost).toFixed(2),
                'packingtotalcost',
                index
              );
            } else if (packingtype === 'thermacol') {
              const vol = packingHeight * packingWidth * packingLength;
              const sizerate = (vol * packingcost) / 480249000;
              const total = sizerate * value;
              handleChange('Costingpacking', sizerate.toFixed(2), 'packingsizeRate', index);
              handleChange('Costingpacking', total.toFixed(2), 'packingtotalcost', index);
            }
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'Total Cost',
      key: 'totalcost',
      fixed: false,
      renderCell: (_, index) => (
        <CustomInput
          step={null}
          placeholder="0.00"
          value={costingTableData.Costingpacking[index]?.packingtotalcost || 0}
          onChange={value => {
            handleChange('Costingpacking', value.toFixed(2), 'packingtotalcost', index);
            setReload(prev => !prev);
            recalculatePackingCost();
          }}
        />
      )
    },
    {
      label: 'Add Packing',
      key: 'addPacking',
      fixed: false,
      renderCell: (_, index) => (
        <div style={{ textAlign: 'center' }}>
          <Whisper
            followCursor
            placement="right"
            trigger="hover"
            speaker={<Tooltip>Delete</Tooltip>}
          >
            <IconButton
              disabled={!productData.isEdit}
              icon={<TrashIcon />}
              size="sm"
              color="red"
              appearance="primary"
              onClick={() => {
                handleDeleteRow('Costingpacking', index);
                setTimeout(() => {
                  recalculatePackingCost();
                }, 0);
              }}
            />
          </Whisper>
        </div>
      )
    }
  ];

  return { columns, columns1, columns2, columns3, columns4 };
}
